<template>
	<div>
		<router-view v-show="$route.matched.length == 3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length == 2">
			<div class="main-page-content">
				<el-row style="height: 36px">
					<ScreeCompany @ScreeCompany="ScreeCompany" />
				</el-row>

				<ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
					<el-table-column width="200" align="center" label="是否需要增值税">
						<template slot-scope="scope">
							<div>
								<el-switch @change="changeAdded_tax($event,scope.row)" v-model="scope.row.is_added_tax" :active-value="1" :inactive-value="0"></el-switch>
							</div>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import ApeTable from '@/components/ApeTable';
import ScreeCompany from '@/components/ScreeCompany.vue';
import DatePicker from '@/components/DatePicker.vue';
import { mapGetters, mapState } from 'vuex';

export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker,
		ScreeCompany
	},
	data() {
		return {
			id: '',
			allCompany: [],
			allTaxSource: [],

			cantEdit: false,

			// 搜索条件
			searchCondition: {},
			loadingStaus: true,
			columns: [
				{
					title: '公司名称',
					value: 'company_name',
					width: 270,
					header_align: 'center',
					align: 'center'
				},
				{
					title: '服务公司',
					value: 'channel_name',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '公司账号',
					value: 'account',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '开户行',
					value: 'bank',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '企业电话',
					value: 'company_phone',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '税号',
					value: 'taxpayer',
					header_align: 'center',
					align: 'center'
				}
			],
			// 表格列表数据
			companyList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			// 分页的offset,序号列使用
			offset: 0
		};
	},

	computed: {
		...mapGetters(['userPermissions', 'buttonType']),
		...mapState({
			userInfo: (state) => state.userInfo
		})
	},
	watch: {
		'$route.matched': function (n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		}
	},
	methods: {
		async changeAdded_tax(val,option) {
			let params={
				is_added_tax: val,
				company_id:option.company_id,
				channel_name:option.channel_name,
			}
			let data = await this.$api.postAdded_taxUpdate(params);
			if (data) {
				this.$message.success('修改成功');
				this.init();
				console.log(val);
			}
		},
		ScreeCompany(v, name) {
			if (name == 'company') {
				if (v) {
					this.searchCondition.company_id = v;
				} else {
					delete this.searchCondition.company_id;
				}
				this.init('search');
			}

			if (name == 'settlement') {
				if (v) {
					this.searchCondition.channel_account = v;
				} else {
					delete this.searchCondition.channel_account;
				}
				this.init('search');
			}
		},
		// 搜索
		searchButton() {
			console.log(this.searchCondition, 'chaxun ');
			this.init('search');
		},
		// 切换页码操作
		async switchPaging() {
			this.init();
		},

		// 初始化列表
		async init(type) {
			let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {
				page_size: 10,
				current_page: 1
			};
			if (type == 'export') {
				pagingInfo.page_size = 50000;
			} else {
				this.loadingStaus = true;
			}
			if (type == 'search') {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.searchCondition;
			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.postAdded_taxList(searchCondition);

			this.companyList = [];
			this.$nextTick(() => {
				this.companyList = data;
			});
			this.pagingData.total = pages.total;
			this.offset = pages.offset;
			this.loadingStaus = false;
		}
	},
	created() {},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.update-btn {
	/deep/ .el-button {
		margin-right: 10px;
	}
}
</style>
